import { Component, OnInit, Input } from '@angular/core';
import { IArticles } from 'src/app/@interfaces/article.interface';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-details-article',
  templateUrl: './details-article.component.html',
  styleUrls: ['./details-article.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    NgxSpinnerModule,
    TranslatePipe,
  ],
})
export class DetailsArticleComponent implements OnInit {
  @Input() article = {} as IArticles;
  companyId = '';

  constructor(private cookieAuthService: CookieAuthService) {}

  ngOnInit(): void {
    this.getAuthValues();
  }

  getAuthValues() {
    const company = this.cookieAuthService.getCompanyObject;
    this.companyId = company!.Id_company!.toString();
  }
}
